import React from 'react';

const GOLD = '#C9A84C';

/**
 * Full-screen state when payment is async-pending or subscription tier is pending_payment.
 */
export default function PaymentProcessingScreen({
  title = 'Payment processing',
  message = "Your payment is being confirmed. We'll unlock Maestro as soon as it clears — usually within a few minutes for bank transfers.",
  onRetrySubscribe,
  onRefresh,
  refreshing = false,
}) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-primary, #0a0a14)',
      padding: 24,
      fontFamily: "'Inter', -apple-system, sans-serif",
    }}>
      <div style={{
        maxWidth: 440,
        width: '100%',
        background: 'var(--bg-primary, #121212)',
        border: '1px solid rgba(201,168,76,0.2)',
        borderRadius: 20,
        padding: 32,
        textAlign: 'center',
        boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: '50%',
          background: 'rgba(201,168,76,0.12)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px',
        }}>
          <div style={{
            width: 28, height: 28,
            border: '3px solid rgba(201,168,76,0.25)',
            borderTopColor: GOLD,
            borderRadius: '50%',
            animation: 'paymentSpin 0.9s linear infinite',
          }} />
          <style>{`@keyframes paymentSpin { to { transform: rotate(360deg); } }`}</style>
        </div>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-primary, #fff)', marginBottom: 10 }}>
          {title}
        </h2>
        <p style={{ fontSize: 15, color: 'var(--text-secondary, rgba(255,255,255,0.55))', lineHeight: 1.6, marginBottom: 24 }}>
          {message}
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {onRefresh && (
            <button
              type="button"
              onClick={onRefresh}
              disabled={refreshing}
              style={{
                width: '100%', fontSize: 15, fontWeight: 700, padding: '14px 0', borderRadius: 12,
                background: GOLD, color: '#1a1a2e', cursor: refreshing ? 'wait' : 'pointer', border: 'none',
                opacity: refreshing ? 0.7 : 1,
              }}
            >
              {refreshing ? 'Checking status…' : 'Check again'}
            </button>
          )}
          {onRetrySubscribe && (
            <button
              type="button"
              onClick={onRetrySubscribe}
              style={{
                width: '100%', fontSize: 14, fontWeight: 600, padding: '12px 0', borderRadius: 12,
                background: 'transparent', color: 'var(--text-secondary, rgba(255,255,255,0.7))',
                border: '1px solid rgba(255,255,255,0.15)', cursor: 'pointer',
              }}
            >
              Try a different payment method
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
